const getList = {};

const getArrayForm = {
  selectAllFormulaProductPageByCond:
    "/nhf-app/formulaproduct/selectAllFormulaProductPageByCond",
  formulaproductDetail: "/nhf-custom/custompro/getCustomProductDetailById",
  selectFormulaProductNutritionByProductId:
    "/nhf-app/formulaproduct/selectFormulaProductNutritionByProductId",
  selectFormulaProductRawByProductId: "/nhf-app/formulaproduct/selectFormulaProductRawByProductId",
  selectFormulaProductRawByProductId2: '/nhf-app/formulaproduct/selectFormulaProductWithoutDelRawByProductId',
  isActivateFormulaProduct: "/nhf-app/formulaproduct/isActivateFormulaProduct",
  // isPushEbsFormulaProduct: "/nhf-app/formulaproduct/isPushEbsFormulaProduct",
  isPushEbsFormulaProduct: "/nhf-app/formulaproduct/pushEbsrPoductId",
  subFactoryList: '/iot-factory/factorysublink/subFactoryList', // 查询关联工厂
  // 产品详情
  getCustomProRawByProductId: '/nhf-custom/archivedCustomProduct/getArchivedCustomProRawByProductId', // 产品详情-配方原料
  getCustomProNutritionByProductId: '/nhf-custom/archivedCustomProduct/getArchivedCustomProNutritionByProductId',// 产品详情-配方营养需要量
  isActivateCustomPro: '/nhf-custom/custompro/isActivateCustomPro', // 产品列表-激活
};

const postArray = {
  batchUpdateProductStatus: '/nhf-app/formulaproduct/batchUpdateProductStatus',
  copyFormulaProduct: "/nhf-app/formulaproduct/copyFormulaProduct",
  batchPushEbsProductIds: '/nhf-app/formulaproduct/batchPushEbsProductIds',
  // 定制料
  getCustomProPageByCond: '/nhf-custom/archivedCustomProduct/pageArchivedCustomProductByCond',
  removeCustomProByIds: '/nhf-custom/custompro/removeCustomProByIds', // 定制料产品删除
  batchSetActivateFlagByFormulaProductIds: '/nhf-custom/custompro/batchSetActivateFlagByFormulaProductIds'
};

const postFormArray = {
  saveFormulaInfoPro: "/nhf-app/formulaproduct/saveFormulaInfoPro",
  removeFormulaProductIds: "/nhf-app/formulaproduct/removeFormulaProductIds",
  // 定制料
};

const baseApi = (arr, method) => {
  let list = {};
  for (let i in arr) {
    list[i] = async (data) => method(arr[i], data);
  }
  return list;
};
import { get, getForm, post, postForm } from "@/Utils/axios";

export const productMixins = {
  data() {
    return {
      raw: [],
      model: {
        records: [],
      },
      visible: false,
      list: {
        records: [],
      },
      modelDetail: {},
      nutrition: [],
      modelLoading: false,
      updateLoading: false,
      selectedRowKeys: [],
      selectedRows: [],
      pagination: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 12 },
      },
      factoryId: null,
      bodyStyle: {
        padding: "0 15px 15px",
      },
      currentPage: {
        current: 1,
        size: 20,
      },
    };
  },
  mounted() {
    this.formulaId = this.$route.query ? this.$route.query.id || null : null;
    this.factoryId = window.localStorage.getItem("factoryId") || null;
  },

  methods: {
    ...baseApi(getList, get),
    ...baseApi(getArrayForm, getForm),
    ...baseApi(postArray, post),
    ...baseApi(postFormArray, postForm),

    numberText(val = 0) {
      return val !== null ? +val : 0;
    },
    toggleVisible() {
      this.visible = !this.visible;
    },

    // normal page
    pageSetting() {
      return {
        size: 20,
        current: 1,
      };
    },

    async fetchGet({ actions, name, data = {}, isList, loading }) {
      if (actions) {
        try {
          if (loading) this[loading] = true;
          let params = isList ? { ...this.pageSetting(), ...data } : data;
          const res = await actions(params);
          if (name) this[name] = res.data;
          if (isList) this.setPager(res.data);
          if (!res.success && name) this.$message.warn(res.msg);
          return res;
        } catch (error) {
          error.msg && this.$message.warn(error.msg);
        } finally {
          if (loading) this[loading] = false;
        }
      }
    },

    async fetchPost({ actions, data, loading,isList, name, showMessage = true }) {
      try {
        if (loading) this[loading] = true;
        const res = await actions(data);
        showMessage && res.msg !== "" && this.$message.success(res.msg);
        if (name) this[name] = res.data;
        if (isList) this.setPager(res.data);
        return res.data;
      } catch (error) {
        error.msg && this.$message.warn(error.msg);
      } finally {
        if (loading) this[loading] = false;
      }
    },

    // 设置分页
    setPager(res) {
      const { total, current, size: pageSize } = res;
      this.pagination = {
        ...this.pagination,
        pageSizeOptions: ["10", "20", "30", "40", "50", "100"],
        pageSize,
        total,
        current,
        showSizeChanger: true,
        showTotal: (total) => <div style="flex:1">共{total}条记录</div>,
      };
    },

    cleanSelect() {
      this.selectedRowKeys = [];
      this.selectedRows = [];
    },

    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys;
      let arr = [...this.selectedRows, ...selectedRows];
      this.selectedRows = selectedRowKeys.map((i) => {
        return arr.filter((item) => item.id === i)[0];
      });
    },

    tablePageChange(page) {
      const { current = 1, pageSize: size } = page;
      this.currentPage = {
        size,
        current,
      };
      return {
        size,
        current,
      };
    },
    fixedNumber(num, len) {
      return num ? Math.round((num + Number.EPSILON) * len) / len : undefined;
    },
    // 乘法
    mul(...val) {
      const strVal = val[0].toString();
      const strValTwo = val[1].toString();
      const index = strVal.indexOf(".");
      const indexTwo = strValTwo.indexOf(".");
      const num = [0, 0];
      if (index > -1) {
        num[0] = strVal.length - 1 - index;
      }
      if (indexTwo > -1) {
        num[1] = strValTwo.length - 1 - index;
      }
      return (
        Math.round(
          val[0] * Math.pow(10, num[0]) * (val[1] * Math.pow(10, num[1]))
        ) / Math.pow(10, num[0] + num[1])
      );
    },
    // 加法
    add(...val) {
      let max = 0;
      let count = 0;
      for (let i = 0; i < val.length; i++) {
        const strVal = val[i].toString();
        const index = strVal.indexOf(".");
        let num = 0;
        if (index > -1) {
          num = strVal.length - 1 - index;
          max = num > max ? num : max;
        }
      }
      for (let i = 0; i < val.length; i++) {
        count += Math.round(val[i] * Math.pow(10, max));
      }
      return count / Math.pow(10, max);
    },
    // 减法
    sub(arg1, arg2) {
      var r1, r2, m, n;
      try {
        r1 = arg1.toString().split(".")[1].length;
      } catch (e) {
        r1 = 0;
      }
      try {
        r2 = arg2.toString().split(".")[1].length;
      } catch (e) {
        r2 = 0;
      }
      m = Math.pow(10, Math.max(r1, r2));
      n = r1 >= r2 ? r1 : r2;
      return +((arg1 * m - arg2 * m) / m).toFixed(n);
    },
    // sub(...val) {
    //   let max = 0;
    //   let count = val[0] | 0;
    //   for (let i = 0; i < val.length; i++) {
    //     const strVal = val[i].toString();
    //     const index = strVal.indexOf(".");
    //     let num = 0;
    //     if (index > -1) {
    //       num = strVal.length - 1 - index;
    //       max = num > max ? num : max;
    //     }
    //   }
    //   for (let i = 0; i < val.length; i++) {
    //     count -= Math.round(val[i] * Math.pow(10, max));
    //   }
    //   return count / Math.pow(10, max);
    // },
    // 除
    div(val, valTwo = 100) {
      const strVal = val.toString();
      const strValTwo = valTwo.toString();
      const index = strVal.indexOf(".");
      const indexTwo = strValTwo.indexOf(".");
      const num = [0, 0];
      if (index > -1) {
        num[0] = strVal.length - 1 - index;
      }
      if (indexTwo > -1) {
        num[1] = strValTwo.length - 1 - index;
      }
      return (
        Math.round(val * Math.pow(10, num[0])) /
        (Math.round(valTwo * Math.pow(10, num[1])) *
          Math.pow(10, num[0] - num[1]))
      );
    },
  },
};
